var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.949 132.752C402.233 136.731 402.233 140.711 402.233 144.691C402.233 266.071 309.848 405.929 140.995 405.929C88.9744 405.929 40.6499 390.863 0 364.711C7.39112 365.564 14.497 365.848 22.1725 365.848C65.0956 365.848 104.609 351.351 136.162 326.62C95.7967 325.767 61.9692 299.331 50.3142 262.945C56 263.797 61.6849 264.366 67.655 264.366C75.8984 264.366 84.1426 263.228 91.8172 261.239C49.7464 252.711 18.1921 215.757 18.1921 171.127V169.991C30.415 176.813 44.6294 181.077 59.6943 181.645C34.9633 165.157 18.7609 137.015 18.7609 105.178C18.7609 88.1222 23.3083 72.4877 31.2681 58.8429C76.4662 114.559 144.406 150.944 220.588 154.924C219.167 148.102 218.313 140.996 218.313 133.889C218.313 83.2895 259.248 42.0718 310.131 42.0718C336.567 42.0718 360.445 53.158 377.217 71.0667C397.968 67.0872 417.866 59.4117 435.491 48.8942C428.668 70.2144 414.171 88.123 395.125 99.4928C413.603 97.5039 431.511 92.386 447.998 85.2801C435.493 103.472 419.857 119.675 401.949 132.752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0c5676e93e61a4530dbc05fb51284b81.svg";
export { ForwardRef as ReactComponent };